export type TimeZoneOption = {
  value: string
  label: string
}

// IANA identifier reported by the browser (e.g. "America/Mexico_City").
// The backend validates and falls back to the platform default when invalid.
export function browserTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone ?? ""
  } catch {
    return ""
  }
}
